var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-auth-box"},[_c('div',{staticClass:"user-auth-title"},[_vm._v(_vm._s(_vm.propData.title))]),_vm._v(" "),_c('div',{staticClass:"user-auth-message",domProps:{"innerHTML":_vm._s(_vm.propData.messageText)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c562584","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/style-rem-loader??ref--1!./src/lib/ui/default/popup/src/content/warm_prompt.vue
// module id = 1601
// module chunks = 2